

const useForceAuthMiddleware = (req, action, next) => {
    let queryParams = new URLSearchParams(window.location.search);
    const forceAuthParam = queryParams.get("ForceAuth");

   if(forceAuthParam){
        switch (action.type) {
            case 'START_AUTHENTICATE':
                req.url.searchParams.set('ForceAuth', 'true');
                break;
        } 

        next();
    } 
   
  };
  
  export default useForceAuthMiddleware;